module.exports = __webpack_public_path__ + "img/p3-p2-diaoxiang.c97a12bb.gif";